import { intlWeekDay } from './intlDateTimeFormatter';
export var WeekDay;
(function (WeekDay) {
    WeekDay["MONDAY"] = "mon";
    WeekDay["TUESDAY"] = "tue";
    WeekDay["WEDNESDAY"] = "wed";
    WeekDay["THURSDAY"] = "thu";
    WeekDay["FRIDAY"] = "fri";
    WeekDay["SATURDAY"] = "sat";
    WeekDay["SUNDAY"] = "sun";
})(WeekDay || (WeekDay = {}));
/*
    To have the right order of the days of the week, we need a base day to start from.
    We chose that monday is the base from which we calculate the other days from.

    example:
    When the day of the week starts on wednesday, monday will be 5 places further in the week.
    wed | thu | fri | sat | sun | mon
    0   | 1   | 2   | 3   | 4   | 5
 */
export const startDayOfTheWeekMap = {
    [WeekDay.MONDAY]: { startDayDate: new Date('2024-01-01'), mondayOffset: 0 },
    [WeekDay.TUESDAY]: { startDayDate: new Date('2024-01-02'), mondayOffset: 6 },
    [WeekDay.WEDNESDAY]: { startDayDate: new Date('2024-01-03'), mondayOffset: 5 },
    [WeekDay.THURSDAY]: { startDayDate: new Date('2024-01-04'), mondayOffset: 4 },
    [WeekDay.FRIDAY]: { startDayDate: new Date('2024-01-05'), mondayOffset: 3 },
    [WeekDay.SATURDAY]: { startDayDate: new Date('2024-01-06'), mondayOffset: 2 },
    [WeekDay.SUNDAY]: { startDayDate: new Date('2024-01-07'), mondayOffset: 1 }
};
export function getWeekDays(startDayOfTheWeek = WeekDay.MONDAY) {
    const startDate = new Date(startDayOfTheWeekMap[startDayOfTheWeek].startDayDate);
    const weekDays = [];
    const startDateNumber = startDate.getDate();
    for (let day = startDateNumber; day <= startDateNumber + 6; day++) {
        startDate.setDate(day);
        weekDays.push(intlWeekDay(startDate));
    }
    return weekDays;
}
